import { defineAsyncComponent } from 'vue';
import type { Component } from 'vue';
import { logger } from '@/shared/common/utils/logger.util';
import LayoutContentFallback from '../components/LayoutContentFallback/index.vue';
import type { LayoutContentGate } from '../types/mainLayout.type';

/**
 * Envuelve la carga diferida del gate de MainLayout.
 * Si el chunk no baja, loguea y resuelve al contenido normal del layout: el gate envuelve
 * `RouterView`, y un `errorComponent` de Vue no recibe el slot, dejaría la ruta vacía.
 */
export function createLayoutContentGate(
  loadGate: () => Promise<{ default: Component }>
): LayoutContentGate {
  return defineAsyncComponent(() =>
    loadGate().catch((error: unknown) => {
      logger.error('[createLayoutContentGate] Error al cargar el gate del layout', {
        error,
      });
      return LayoutContentFallback;
    })
  );
}
